import {Type, Expose, plainToClass} from "class-transformer";
import {AxiosResponse} from "axios";
import {ResponseContent} from "@/api/types";


export class PaceDTO {
  @Expose({ name: "observable_date" })
  @Type(() => Date)
  public observableDate!: Date;

  @Expose({ name: "target_area" })
  public targetArea!: number;

  @Expose({ name: "planted_area" })
  public plantedArea!: number;

  @Expose({ name: "harvested_area" })
  public harvestedArea!: number;

  @Expose({ name: "average_planting_date" })
  @Type(() => Date)
  public averagePlantingDate!: Date | null;

  @Expose({ name: "average_harvest_date" })
  @Type(() => Date)
  public averageHarvestDate!: Date | null;
}

export class YearSummaryDTO {
  @Expose({ name: "analysis_uuid" })
  public analysisUuid!: string;

  @Expose({ name: "harvest_year" })
  public harvestYear!: number;

  @Expose({ name: "harvest_season" })
  public harvestSeason!: string;

  @Expose({ name: "crop_type" })
  public cropType!: string;

  @Expose({ name: "target_area" })
  public targetArea!: number;

  @Type(() => PaceDTO)
  @Expose({ name: "paces" })
  public paces!: PaceDTO[];
}

export class AnalysisPaceDTO {
  @Expose({ name: "senana_analysis_uuid" })
  public senanaAnalysisUuid!: string;

  @Expose({ name: "total_area" })
  public totalArea!: number;

  @Type(() => YearSummaryDTO)
  @Expose({ name: "years" })
  public years!: YearSummaryDTO[];
}
